import React from "react";
import { Col, Container, Row } from "shards-react";

import { getUsers } from "../backend/user";
import PageTitle from "../components/common/PageTitle";
import UserAction from "../components/layout/user/userAction";
import UserDetails from "../components/user-profile/UserDetails";
import { AdminBand } from "../utils/adminbar";
import BovinePrice from "../components/common/BovinePrice";

class UserProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeUser: this.props.location.state?.activeUser
        ? this.props.location.state.activeUser
        : this.props.user.user,
      users: [],
    };
  }

  componentDidMount() {
    if (
      this.props.user.user.privileges === "admin" &&
      this.state.users.length === 0
    ) {
      getUsers((data) => {
        this.setState({ users: data.users });
      });
    }
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Perfil del usuario"
            subtitle={this.state.activeUser.username}
            className="text-sm-left"
          />
        </Row>
        <AdminBand
          users={this.state.users}
          activeUser={this.state.activeUser}
          onChange={(event) => {
            this.setState({
              activeUser: this.state.users.find(
                (element) => element.username === event.target.value
              ),
            });
          }}
        />

        <Row>
          <Col>
            <UserDetails userDetails={this.state.activeUser} />
          </Col>
          <Col>
            <UserAction activeUser={this.state.activeUser} />
          </Col>
        </Row>
        <Row className={"pt-2"}>
          <Col>
            <BovinePrice />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default UserProfile;
